<template>
  <div class="ml-6 mr-6" :style="navbarWithName ? 'margin-left: 165px !important; margin-right: auto !important;' : ''">
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="page" class="pa-0 ma-0 my-6 mt-0 pt-0"></v-breadcrumbs>
    


    <template>
      <v-toolbar flat class="rounded-lg">
        <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-family-tree</v-icon>{{ this.$store.state.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-flex lg3>
          <!-- <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field> -->
        </v-flex>
        <v-dialog v-model="dialogDelete" width="330px">
          <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
            <v-avatar class="color-warnning my-4" size="62">
              <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
            </v-avatar>
            <div class="text-center text-h6 align-center justify-center font-weight-medium">
              Confirm Deletion
            </div> 
            <v-card-text class="align-center justify-center mt-2">
              Are you sure you want to delete this chart ?
            </v-card-text>
            <v-divider class="mt-4" style=""></v-divider>
            <v-card-actions class="align-center justify-center">
              <v-btn rounded class="my-3 btn-ok-delete" width="90px" dark @click="deleteItemConfirm">
                OK
              </v-btn>
              <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                Cancel 
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDeleteQuery" width="330px">
          <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
            <v-avatar class="color-warnning my-4" size="62">
              <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
            </v-avatar>
            <div class="text-center text-h6 align-center justify-center font-weight-medium">
              Confirm Deletion
            </div> 
            <v-card-text class="align-center justify-center mt-2">
              Are you sure you want to delete this Query Monitoring ?
            </v-card-text>
            <v-divider class="mt-4" style=""></v-divider>
            <v-card-actions class="align-center justify-center">
              <v-btn rounded class="my-3 btn-ok-delete" width="90px" dark @click="deleteItemConfirmQuery">
                OK
              </v-btn>

              <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDeleteQuery">
                Cancel 
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        
      </v-toolbar>
    </template>



    <v-btn class="color-avatar3" fab dark fixed bottom right color="primary">
      <v-icon>mdi-chevron-down</v-icon>
    </v-btn>
    <v-row class="align-center mb-2"
    
     :style="{ margin : '0px' }"
    >
      <v-col cols="8" class="pa-0">
          <v-tabs
            v-model="selectedServer"
            background-color="#0471A5"
            dark
            slider-color="#FFC107"  
            show-arrows              

            class="custom-tabs rounded-tabs"
          >
          <v-tab v-for="(server, index) in servers" :key="index">
            {{ server.NAME_SERVER }}
          </v-tab>
        </v-tabs>
      </v-col>
      <v-col cols="4" class="pa-0">
        <div class="d-flex align-center justify-end flex-wrap">
          <v-select 
                :style="{ marginLeft : '80px',width: '220px', paddingTop: '17px' }"
                rounded 
                background-color="#0471A5" 
                dark 
                dense 
                solo 
                :items="periodeberita" v-model="selectedPeriode" label="Periode Berita"  @change="loaddatamonitoring">
          </v-select>
          
          <v-divider></v-divider>

          <v-btn
            class="mr-2 mb-2"
            color="#a80202"
            variant="outlined"
            rounded
            @click="dialogConfirmReset"
          >
            <v-icon left>mdi-reload</v-icon>
            
          </v-btn>
          <v-menu offset-y bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                rounded
                color="primary"
                class="mr-2 mb-2"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left>mdi-cog</v-icon>
                Setting
              </v-btn>
            </template>
            <v-list style="min-width: 250px;">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2 font-weight-bold">
                    Setting Monitoring
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item left v-if="btnShowActin" >
                <v-btn
                  text
                  large
                  color="primary"
                  @click="addMonitoring()"
                  
                >
                  <v-icon left small>mdi-plus</v-icon>
                  Add Monitoring
                </v-btn>
              </v-list-item>

              <!-- Tombol Update Monitoring -->
              <v-list-item left v-if="btnShowActin">
                <v-btn
                  text
                  large
                  color="primary"
                  @click="suntingMonitoring()"
                >
                  <v-icon left small>mdi-pencil</v-icon>
                  Update Monitoring
                </v-btn>
              </v-list-item>

              <!-- Tombol Update Monitoring -->
              <v-list-item left v-if="btnShowActin">
                <v-btn
                  text
                  large
                  color="primary"
                  @click="queryMonitoring()"
                >
                  <v-icon left small>mdi-cube</v-icon>
                  Query Monitoring
                </v-btn>
              </v-list-item>

              <!-- Tombol Finish Update -->
              <v-list-item left v-if="btnActionSunting">
                <v-btn
                  text
                  large
                  color="primary"
                  @click="finishSuntingMonitoring()"
                >
                  <v-icon left small>mdi-check-circle</v-icon>
                  Finish Update
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>

        </div>
      </v-col>
    </v-row>
    


    <v-tabs-items v-model="selectedServer" class="tab-content-elevated">

      <v-tab-item v-for="(server, index) in servers" :key="index">

        <v-row wrap class="mb-4 " style="margin-top: 2px;" >
          <v-flex  v-for="(monitor, idx) in server.PAR_MONITORING_SERVERs" :key="idx" lg="4" sm="12" class="chart-container" :style="monitor.NAME == 'Memory Usage Server/VM' || monitor.NAME == 'Memory Usage Solr'  || monitor.NAME == 'Disk Usage Collection'  ? 'width: 797px' : ''">
            <v-card-title>{{ monitor.NAME }} 
              <v-spacer></v-spacer>
              <v-btn v-show=btnActionChart small class="blue mx-2 elevation-0" @click="updateMonitoringAction(monitor,server.HOST_SOLR,server.HOST,server.HOST_RANGE)" dark outlined icon color="#fff">
                <v-icon style="font-size: 14px;">mdi-pencil</v-icon>
              </v-btn>

              <v-btn v-show=btnActionChart  small class="red elevation-0" @click="deleteItem(monitor.SEQ_ID)" outlined color="#fff" icon>
                <v-icon  style="font-size: 14px;">mdi-delete-outline</v-icon>
              </v-btn>

            </v-card-title>
            <v-row v-if="monitor.NAME == 'Memory Usage Server/VM' || monitor.NAME == 'Memory Usage Solr' " >
                <apexcharts height="230px"
                :type="monitor.TYPE" 
                :options="getChartOptions(monitor, categories[monitor.SEQ_ID] )" 
                :series="chartSeries[monitor.SEQ_ID] "></apexcharts>
                <v-simple-table v-if="monitor.NAME == 'Memory Usage Server/VM' || monitor.NAME == 'Memory Usage Solr' " :style="monitor.NAME === 'Memory Usage Server/VM' || monitor.NAME == 'Memory Usage Solr' ? 'width: 497px;background-color:#ffffff0d;' : ''">
                  <tbody>
                    <tr>
                      <th :style="'width: 197px'" class="text-left">CPU</th>
                      <td>{{ tableDataVal[monitor.SEQ_ID]?.CPU || '-' }}</td>
                    </tr>
                    <tr>
                      <th class="text-left">Heap</th>
                      <td>
                        <h3
                          :style="{
                            color: getHeapColor(tableDataVal[monitor.SEQ_ID]?.Heap.presentase)
                          }"
                        >
                          {{ tableDataVal[monitor.SEQ_ID]?.Heap.presentase || '-' }}
                        </h3>
                        Max:  {{ tableDataVal[monitor.SEQ_ID]?.Heap.max || '-' }}<br>
                        Used:  {{ tableDataVal[monitor.SEQ_ID]?.Heap.used|| '-' }}
                      </td>
                    </tr>
                    <tr>
                      <th class="text-left">Disk usage</th>
                      <td> {{ tableDataVal[monitor.SEQ_ID]?.DiskUsageSolr|| '-' }}</td>
                    </tr>
                    <tr v-if="monitor.NAME == 'Memory Usage Solr'" >
                      <th class="text-left">Requests</th>
                      <td> {{ tableDataVal[monitor.SEQ_ID]?.Requests|| '-' }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-row >
               <!-- monitor.NAME == 'Disk Usage Collection' -->
            <apexcharts  v-else 

              :height="monitor.NAME === 'Disk Usage Collection' ? '397px' : '230px'"
              :type="monitor.TYPE" 
              :options="getChartOptions(monitor, categories[monitor.SEQ_ID])" 
              :series="chartSeries[monitor.SEQ_ID] "></apexcharts>
             

          </v-flex>


        </v-row>
      </v-tab-item>
    </v-tabs-items>

    



    <!-- display add chart  -->
    <!-- display add chart  -->
    <!-- display add chart  -->
    <!-- display add chart  -->
    <!-- dialog action monitorinhg  -->
    <v-dialog v-model="dialogactionmonitoring" max-width="90%">
      <v-card>
        <v-card-title>
          <span class="text-h6">Chart {{ this.$store.state.title }}</span>
        </v-card-title>
        <v-card-text class="overflow-card">
          <v-layout row wrap class="my-6">
            <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-select
                class="elevation-0 shadow-0"
                dense
                outlined
                rounded
                :items="serversSelect"
                item-text="NAME_SERVER"
                item-value="SEQ_ID"
                v-model="selectedServerId"
                @change="sendtmp"
                label="Choose Server"
              />
            </v-col>
            <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-select
                class="elevation-0 shadow-0"
                dense
                outlined
                rounded
                :items="itemtypechart"
                item-text="chart"
                v-model="typechart"
                
                @change="selecttypechart"
                label="Type"
              />
            </v-col>
            <v-col v-if="donut_attr"  class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-select
                class="elevation-0 shadow-0"
                dense
                outlined
                rounded
                :items="itemtypeDonut"
                item-text="chart"
                v-model="nameChartDonut"
                label="Name Chart"
              />
            </v-col>
            <v-col v-if="area_attr" class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-select
                class="elevation-0 shadow-0"
                dense
                outlined
                rounded
                :items="matricexplorer"
                item-text="NAME_QUERY"
                item-value="QUERY"
                v-model="matricexplorerAdd"
                label="Matric Explorer"
                solo
                hide-details
                :search-input.sync="searchQuery"
                :filter="filterItems"
              />
            </v-col>
            <v-col v-if="area_attr" class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-text-field
                class="elevation-0 shadow-0"
                dense
                outlined
                rounded
                v-model="namechart"
                label="name Chart"
              />
            </v-col>

            <v-col v-if="bar_attr"  class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-select
                class="elevation-0 shadow-0"
                dense
                outlined
                rounded
                :items="itemtypeBar"
                item-text="chart"
                v-model="nameChartBar"
                label="Name Chart"
              />
            </v-col>
            <v-col class="d-flex ma-0 pa-0" sm="2">
              <v-btn
                color="green darken-1"
                style="width: 130px;"
                rounded
                dark
                dense
                :loading="btnload"
                @click="displayMonitoring"
              >
                Display
              </v-btn>
            </v-col>

          </v-layout>
        </v-card-text>
          
      
        <v-flex lg="12" sm="12" class="chart-container">
          <v-card-title>{{ name_title_monitoring }}</v-card-title>
          <v-row>
            <v-col cols="12" 
            :sm="displayMemoryUsag === true ? 6 : 12"
            class="d-flex justify-center align-center"

              :width="'100%'"
            >
              <apexchart
                ref="apexChartRef"
                :type="type_chart_display"
                :options="chart_display"
                :series="series_display"
              :height="250"
              :width="'1400'"
              ></apexchart>
            </v-col>

            <v-col cols="12" sm="6"  v-if="displayMemoryUsag === true">
              <v-simple-table dense>
                <tbody>
                  <tr>
                    <th  class="text-left">CPU</th>
                    <td>{{ tableData.CPU }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">Heap</th>
                    <td> {{ tableData.Heap.presentase }} <br>
                          Max: {{ tableData.Heap.max }} <br>
                          Used: {{ tableData.Heap.used }}  <br>
                    </td>
                  </tr>
                  <tr>
                    <th class="text-left">Disk usage Solr</th>
                    <td>{{ tableData.DiskUsageSolr }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">Requests</th>
                    <td>{{ tableData.Requests }}</td>
                  </tr>
                </tbody>
              </v-simple-table>

            </v-col>
          </v-row>
        </v-flex>
        
        <v-divider></v-divider>
        <v-card-actions class="py-3">
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            style="width: 90px;"
            rounded
            outlined
            dense
            @click="closeMonitoringAction"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            style="width: 90px;"
            rounded
            dark
            dense
            :loading="btnload"
            @click="postDataMonitoring"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    



    <v-dialog v-model="dialogaQuerymonitoring" max-width="80%">
      <v-card>
        <v-card-title>
          <span class="text-h6">Query Monitoring</span>
        </v-card-title>
        
        <v-card-text class="overflow-card">
        <br>
        <br>

          <v-layout  row wrap align-center justify-end>
            <!-- Search Input -->
            <v-col sm="4" class="pa-0">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                dense
                clearable
              ></v-text-field>
            </v-col>

            <!-- Tombol Tambah Data -->
            <v-col class="d-flex ma-0 pa-0" sm="2">
              <v-divider></v-divider>
              <v-btn
                color="primary"
                rounded
                dense
                @click="generateQuery"
                :loading="btnloadGenerate" 
              >
                <v-icon left>mdi-cogs</v-icon>
                Generate Query
              </v-btn>
            </v-col>

          </v-layout>
        </v-card-text>
        <br>
        <v-card-text class="overflow-card">

          <!-- Data Table -->
          <v-data-table
            :headers="tableHeaders"
            :items="tableItems"
            :search="search"
            item-key="id"
            class="elevation-1"
            dense
            :items-per-page="10"
          >

        <!-- Correct slot usage for item.STATUS -->
        <template v-slot:item.STATUS="{ item }">
          <v-chip :color="getColor(item.STATUS)"  text-color="white" label small pill>
             {{ item.STATUS === 0 ? 'Disabled' : 'Enabled' }}
          </v-chip>
        </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                icon
                small
                  class="mr-2"
                @click="updateDataQuery(item)"
                :disabled="btnload"
                title="Update"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <v-btn
                icon
                small
                  class="mr-2"
                @click="deleteDataQuery(item.SEQ_ID)"
                :disabled="btnload"
                title="Delete"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          

            <template v-slot:no-data>
              No monitoring data found.
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="py-3">
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            style="width: 90px;"
            rounded
            outlined
            dense
            @click="closeMonitoringQuery"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogGenerate" width="330px">
      <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
        <v-avatar class="color-avatar3 my-4" size="62">
          <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
        </v-avatar>
        <div class="text-center text-h6 align-center justify-center font-weight-medium">
          Confirm Generate Data Query
        </div> 
        <v-card-text class="align-center justify-center mt-2">
          Are you sure you want to fetch data Query, there are <b>total {{ countDataQueryGenerate }} data</b> in data?
        </v-card-text>
        <v-divider class="mt-4" style=""></v-divider>
        <v-card-actions class="align-center justify-center">
          <v-btn rounded class="my-3 color-avatar" width="90px"  @click="generateGueryStart">
            YES
          </v-btn>
          <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="dialogGenerate = false">
            Cancel 
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    

    <v-dialog v-model="dialogUpdateQuery" max-width="500px">
      <v-card>
        <v-card-title><span class="text-h6">Update Query Monitoring</span></v-card-title>
        <v-card-text style="height: 400px;" class="overflow-card">
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field outlined dense v-model="iteminput.query" label="Query" 
                hint="Input Query" persistent-hint disabled>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field outlined dense v-model="iteminput.nameQuery" label="Name Query" 
                hint="Input Name Query" persistent-hint>
                </v-text-field>
              </v-col> 
              <v-col cols="12" sm="12" md="12">
                <v-text-field outlined dense v-model="iteminput.description" label="Description" 
                hint="Input Description" persistent-hint>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-select dense outlined :items="itemsactivate"  item-text="name_active" item-value="valueactive"  v-model="statusactive"  
                hint="Activate/Disable crawling person by system" persistent-hint></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text> 

        <v-divider></v-divider>
        <v-card-actions class="py-3">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="closeUpdateQuery">
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="saveQueryMonitoring">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>





    <v-dialog v-model="dialogLoading" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium align-center justify-center">Page loading</v-card-title>
        <v-card-text class="body-1 align-center justify-center">Loading content, please wait</v-card-text>
        <v-card-title class="align-center justify-center">
          <v-progress-circular :size="70" :width="7" color="#0471A5" indeterminate></v-progress-circular>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#0471A5" text @click="dialogLoading = false">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

import { decryptionData,formatBytes,formatBytesAuto,formatMBtoGB,bytesToMBNominal,formatScrapeDuration } from '@/components/utils/utils.js';
import axios from "axios";
import { mapGetters } from 'vuex';

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  data() {
    return {

        hoveredValue: null,
       displayMemoryUsag:false,
       tableData: {
        CPU: '20%',
        Heap: '512MB',
        DiskUsageSolr: '30GB',
        Requests: 1200,
        Collections1: 5,
        Collections2: 3
      },
       tableDataVal: {},
      alertSuccess:false,
      alert_err_attention:'',
      alertFailed:'',
      btnShowActin:true,
      btnActionSunting:false,
      btnActionChart:false,
      searchQuery: '',
      matricexplorerAdd:'',
      seqId:"",
      namechart:"",
      selectedServerId:null,
      tmp_server:null,
      tmp_host:null,
      tmp_host_solr:null,
      tmp_host_range:null,
      btnload:false,
      dialogactionmonitoring:false,
      dialogaQuerymonitoring:false,
      
      setTanggal: [],
      selectedPeriode: "Today",
      dateStart: "",
      dateEnd: "",
      periodeberita: [
        "Today", "Yesterday", "Last 7 Days", "Previous Week", "Last 30 Days", "Previous Month",
      ],
      name_title_monitoring: '',
      series_display: [],

      chart_display: {},
      type_chart_display:"",
      itemtypechart: [
        { chart: 'Donut', value: 'donut' },
        { chart: 'Area', value: 'area' },
        { chart: 'Bar', value: 'bar' }
      ],
      nameChartDonut:"",
      itemtypeDonut: [
        { chart: 'Memory Usage Server/VM', value: 'Memory Usage Server/VM' },
        { chart: 'Memory Usage Solr', value: 'Memory Usage Solr' },
        { chart: 'Swap Space', value: 'Swap Space' },
        { chart: 'File Descriptor Count', value: 'File Descriptor Count' }
      ],
      
      nameChartBar:"Disk Usage Collection",
      itemtypeBar: [
        { chart: 'Disk Usage Collection', value: 'Disk Usage Collection' }
      ],
      
      donut_attr: false,
      area_attr:false,
      bar_attr:false,
      
      

      typechart:"",
      date1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date2: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      showDate1: "",
      showDate2: "",
      dialogLoading: false,
      dialogDelete: false,
      dialogDeleteQuery: false,
        
      alert: false,
      message: "",
      serversSelect: [],
      servers: [],
      selectedServer: 0,
      chartSeries: {},  // Initial values for "Used" and "Free" memory
      categories: {},  // Initial values for "Used" and "Free" memory
      
      totalSwapGb:0,
      totalSwap: 0,
      usedSwap: 0,
      freeSwap: 0,
      // == memory 
      chartOptions: '',
      // == swap 
      chartSwapSeries: [0, 0],  // Initial values for "Used" and "Free" memory
      chartSwapOptions:"",

      // == file count 
      chartFileCountSeries: [0, 0],  // Initial values for "Used" and "Free" memory
      chartFileCountOptions: '',
      search: '',
      tableHeaders: [
        // { text: 'ID', value: 'SEQ_ID' },
        { text: 'NAME QUERY', value: 'NAME_QUERY' },
        { text: 'QUERY', value: 'QUERY' },
        { text: 'DESCRIPTION', value: 'DESCRIPTION' },
        { text: 'STATUS', value: 'STATUS' },
        // { text: 'USER_CREATED_ID', value: 'USER_CREATED_ID' },
        // { text: 'CREATED_AT', value: 'CREATED_AT' },
        { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
      ],
      tableItems: [],
      countDataQueryGenerate:'',
      baseurlgenerate:'',
      matricexplorer:[],
      btnloadGenerate:false,
      dialogGenerate:false,
      dialogUpdateQuery:false,

      iteminput: {
      },
      
      statusactive: 1,
      itemsactivate: [//choice select
        {valueactive: 1, name_active: "Enabled" },
        {valueactive: 0, name_active: "Disabled" }
      ],
      


    };
  },
  computed: {
    page() {
      return this.$store.state.breadcrumbs
    },
    ...mapGetters(['navbarWithName']),
    
  },
  mounted() {
    this.loaddatamonitoring();
    
  },
  
  watch: {
    dialogactionmonitoring (val) {
      val || this.closeMonitoringAction()
    },
    dialogaQuerymonitoring (val) {
      val || this.closeMonitoringQuery()
    },
    
    
    dialogDelete (val) {
      val || this.closeDelete()
    },

    dialogDeleteQuery (val) {
      val || this.closeDeleteQuery()
    },

    dialogUpdateQuery (val) {
      val || this.closeUpdateQuery()
    },
    
  },
  methods: {
    
    getHeapColor(value) {
      const num = parseFloat(value);
      if (isNaN(num)) return 'black'; // fallback
      if (num >= 90) return 'red';
      if (num >= 70) return 'blue';
      if (num >= 40) return 'green';
      return 'black';
    },
    getColor(status) {
      return status === 0 ? 'red' : 'blue';
    },

    async generateGueryStart () {
      this.dialogLoading = true;
      for (let data of this.matricexplorer) {
        const hasil = await this.generateInsertOne(data.MATRIC.toUpperCase(), data.MATRIC);
        console.log(hasil); // You can log or process the result as needed.
      }
      this.queryMonitoring()
      this.dialogLoading = false;
      this.dialogGenerate = false;
      

    },

    async generateInsertOne (name_query, query) {
      try {
        const response = await axios.post("/query-monitoring-generate", {
          name_query:  name_query,
          query:  query
        }, {
          headers: {
            'auth-token': localStorage.getItem('token_app')
          }
        });

        const { status, msg } = response.data;

        if (status === 200) {
          return { success: true, message: msg }; // Return a success response object
        } else {
          return { success: false, message: msg }; // Return failure response object
        }

      } catch (e) {
        if (e.response) {
          switch (e.response.status) {
            case 404:
              return { success: false, message: 'Not Found (404)' };
            case 403:
              return { success: false, message: 'Forbidden (403)' };
            case 400:
              return { success: false, message: e.response.data.msg };
            default:
              console.error('Some other error occurred', e);
              return { success: false, message: 'An unexpected error occurred' };
          }
        } else {
          console.error('Network or other error:', e);
          return { success: false, message: 'Network error or other issue' };
        }
      }
    },
    async generateQuery () {
      try {
        this.btnloadGenerate = true
        const response = await axios.get(this.baseurlgenerate);
        const metricData = response.data.data;
        this.matricexplorer = metricData.map((item) => ({
          MATRIC: item,
          SEQ_ID_MATRIC: item // Atau ID lainnya yang relevan
        }));
        // var no = 0;
        // for (let data of this.matricexplorer) {
        //   no++
        //   // const hasil = await this.generateInsertOne(data.MATRIC.toUpperCase(), 'Prometheus', data.MATRIC);
        //   console.log(data); // You can log or process the result as needed.
        // }
        this.countDataQueryGenerate = this.matricexplorer.length;
        this.btnloadGenerate = false
        this.dialogGenerate = true
      } catch (error) {
        console.error("Error fetching metric data:", error);
      }
    },

    queryMonitoring(){
      this.dialogLoading = true;


        axios.get("/query-monitoring",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            // this.variableparameter = response.data;
            var res = decryptionData(response.data.token);
            this.tableItems = res.data;
            this.baseurlgenerate =res.baseurl_prometheus;
            // auth action  
            this.QueryRefresh()
            setTimeout(() =>{
              this.loading = false
              this.dialogaQuerymonitoring = true
            this.dialogLoading = false;

            },1000)
          })
          .catch((e) => {
              switch (e.response.status) {
                  case 404:
                        this.$refs.alert.error_login(404);
                      break;
                  case 403:
                        this.$refs.alert.error_login(403);
                      break;
                  default:
                      console.log('some other error');  // end up here all the time
                      break;
              }
            this.errors=e.response.data.msg;
            this.dialogLoading = false;

        });

        
    },

    async QueryRefresh () {
      try {
      const result = await axios.post(
        'monitoring', // URL endpoint
        {}, // Data yang dikirimkan (kosong jika tidak ada data yang dikirim)
        {
          headers: {
            'auth-token': localStorage.getItem('token_app')
          },
          // Axios secara otomatis mengonversi respons ke JSON, jadi tidak perlu menambahkan 'dataType: 'json''
        }
      );
      

      var data = decryptionData(result.data);
      this.matricexplorer = data.data.list_query

      } catch (error) {
        console.error("Error fetching metric data:", error);
      }
    },
    closeDelete () {
        this.dialogDelete = false
        this.seqId = ""
        this.btnload = false

    },

    updateDataQuery(item){ 
        this.seqId = item.SEQ_ID

        this.iteminput = {
          query:item.QUERY,
          nameQuery:item.NAME_QUERY,
          description:item.DESCRIPTION,
        }
        this.statusactive =item.STATUS
      this.dialogUpdateQuery = true

    },
    deleteDataQuery(seq_id){ 
      this.seqId = seq_id
      this.dialogDeleteQuery = true
    },
    closeDeleteQuery () {
        this.dialogDeleteQuery = false
        this.seqId = ""
        this.btnload = false

    },

    closeUpdateQuery () {
        this.dialogUpdateQuery = false
        this.seqId = ""
        this.btnload = false

    },
    
    saveQueryMonitoring () {
    this.dialogLoading = true;

      axios.put("/query-monitoring-update", 
        {
          seq_id:this.seqId,
          query:this.iteminput.query,
          nameQuery:this.iteminput.nameQuery,
          description:this.iteminput.description,
          statusactive:this.statusactive,
        },
        
        {headers:{'auth-token':localStorage.getItem('token_app')}},
        {dataType: 'json'}
        )
      .then((response) => {
          // this.initialize();
          // this.$router.push('/botaccount');
          // alert('okk');      
          console.log(response.data);  
          this.dialogLoading = false;
          this. queryMonitoring()
        })
      .catch((e) => {
            switch (e.response.status) {
                case 404:
                      this.$refs.alert.error_login(404);
                    break;
                case 403:
                      this.$refs.alert.error_login(403);
                    break;
                default:
                    console.log('some other error');  // end up here all the time
                    break;
                }
        this.errors=e.response.data.msg;
          this.dialogLoading = false;

      });
      
      this.closeUpdateQuery();
    },
  
    deleteItemConfirmQuery () {
      this.dialogLoading = true;

      axios({
        method: "delete",
        url: "/query-monitoring-delete",
        data: {
          seq_id: this.seqId
        },
        headers:{'auth-token':localStorage.getItem('token_app')},
        dataType: 'json'
      })
      .then((response) => {
        // handle success
            this.queryMonitoring()
            var status = response.data.status
            var messages = response.data.msg
            if(status == 200){
              this.alertSuccess = true;
              this.alert_err_attention =  messages;
              this.btnload = false
              this.closeDeleteQuery()
            }else{
                this.alertFailed = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.closeDeleteQuery()
            } 
      this.dialogLoading = false;

      })
      .catch(function (error) {
        console.log(error);
        this.alertFailed = true;
        this.alert_err_attention =  'Delete Failed';
        this.btnload = false
      this.dialogLoading = false;

      })
    },










    getChartOptions(monitor, categories = []) {
      let label = [];
      let unit = " GB"
      if(monitor.TYPE == 'donut'){
        
          if (monitor.NAME === 'Memory Usage Server/VM') {
            label = ['Memory Used', 'Free Memory'];
          }

          if (monitor.NAME === 'Memory Usage Solr') {
            label = ['Used', 'Free'];
          }
          if (monitor.NAME === 'Swap Space') {
            label = ['Used Swap', 'Free Swap'];
          }
          
          if (monitor.NAME === 'File Descriptor Count') {
            label = ['Used File Count', 'Availabel File Count'];
            unit = " Mil"
          }

          // ================== donut 

          if (monitor.NAME == 'Memory Usage Solr') {
            return {
              labels: label,
              legend: {
                    position: 'bottom',
                  },
                  
              tooltip: {
                y: {
                  formatter: function (val) {
                      return val +` MB`;
                  }
                }
              },
              
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      name: {
                        show: true,
                        fontSize: '22px',
                        color: '#226077',
                        offsetY: -10,
                      },
                      total: {
                        show: true,
                        formatter: function (w) {
                          // Format the total value to two decimal places
                          // return w.globals.seriesTotals.reduce((a, b) => a + b, 0).toFixed(2) + unit; // Example: Show in GB
                            return formatMBtoGB(w.globals.seriesTotals.reduce((a, b) => a + b, 0)) ; // Example: Show in GB
                        }
                      },
                    }
                  }
                }
              },
            };
          }else{
            return {
              labels: label,
              legend: {
                    position: 'bottom',
                  },
                  
              tooltip: {
                y: {
                  formatter: function (val) {
                    return `${val} `+unit; // Show GB in tooltip
                  }
                }
              },
              
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      name: {
                        show: true,
                        fontSize: '22px',
                        color: '#226077',
                        offsetY: -10,
                      },
                      total: {
                        show: true,
                        formatter: function (w) {
                          // Format the total value to two decimal places
                          return w.globals.seriesTotals.reduce((a, b) => a + b, 0).toFixed(2) + unit; // Example: Show in GB
                        }
                      },
                    }
                  }
                }
              },
            };
          }

      }else  if(monitor.TYPE == 'bar'){
            // let categories = []
            return {
                name: 'Available Memory',
                chart: {
                  id: monitor.SEQ_ID,
                  type: 'bar', 
                  animations: {
                    enabled: true,
                    // easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  zoom: {
                    enabled: false
                  }
                },
                xaxis: {
                  categories: categories,
                  labels: {
                    rotate: -45
                  }
                },
                yaxis: {
                  // logarithmic: true, // ini kuncinya

                  min: 1000000,
                  labels: {
                    formatter: function (val) {
                      if (val >= 1000000000) return (val / 1000000000).toFixed(2) + ' GB';
                      if (val >= 1000000) return (val / 1000000).toFixed(2) + ' MB';
                      return val + ' B';
                    }
                  }
                },
            
                dataLabels: {
                  enabled: true,
                  // formatter: val => `${(val)} MB`
                  formatter: function (val) {
                    if (val >= 1000000000) {
                      return (val / 1000000000).toFixed(2) + ' GB';
                    } else if (val >= 1000000) {
                      return (val / 1000000).toFixed(2) + ' MB';
                    } else {
                      return val.toLocaleString() + ' Bytes';
                    }
                  },
                  style: {
                    fontSize: '12px',
                    fontWeight: 'bold',
                    colors: ['#304758'],
                    // Tidak ada rotate native, tapi bisa sesuaikan posisi pakai offsetX dan offsetY
                  },
                  offsetY: -10, // pindahkan label sedikit ke atas batang
                  offsetX: 0,
                },
                stroke: {
                  curve: 'smooth',
                  colors: ['#00E396', '#FF4560'],
                },
                tooltip: {
                  y: {
                    // formatter: val => `${(val)} MB`

                      formatter: function (val) {
                        if (val >= 1000000000) {
                          return (val / 1000000000).toFixed(2) + ' GB';
                        } else if (val >= 1000000) {
                          return (val / 1000000).toFixed(2) + ' MB';
                        } else {
                          return val.toLocaleString() + ' Bytes';
                        }
                      }
                  }
                },
                plotOptions: {
                  bar: {
                    horizontal: false
                  }
                },
                legend: {
                  position: 'top',
                },
            };

      }else{
            return {
              
                name: 'Available Memory',
                chart: {
                  id: monitor.SEQ_ID,
                  type: 'area', 
                  animations: {
                    enabled: true,
                    // easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  zoom: {
                    enabled: false
                  }
                },
                dataLabels: {
                  enabled: false
                },
                stroke: {
                  curve: 'smooth',
                  colors: ['#00E396', '#FF4560'],
                },
                xaxis: {
                  type: 'datetime', // For time series data
                },
                yaxis: {
                  labels: {
                    formatter: function (val) {
                      var y = ''
                      if(val < 10000000){
                        y = val
                      }else{
                        var result_gb = parseFloat(val / (1024 * 1024 * 1024)).toFixed(2)
                        y =`${result_gb} GB`
                      }

                      return y;
                    }
                  }
                },
                tooltip: {
                  x: {
                    format: 'dd MMM yyyy HH:mm:ss', // Format for datetime tooltip
                  },
                  y: {
                    formatter: function (val) {
                      var y = ''
                      if(val < 10000000){
                        y = val
                      }else{
                        var result_gb = parseFloat(val / (1024 * 1024 * 1024)).toFixed(2)
                        y =`${result_gb} GB`
                      }

                      return y;
                    }
                  },
                  // Menambahkan Judul Tooltip
                  title: {
                    text: 'volume',
                  }
                },
                legend: {
                  position: 'top',
                },
            };


        }
    },
    async getChartData(server, monitor) {
        let prometheusUrlRange = server.HOST_RANGE;
        let prometheusUrl = server.HOST;
        // let hostSolr = server.HOST_SOLR;
        const datest = new Date(this.dateStart + 'T00:00:00Z');
        const unixTimestamp = datest.getTime() / 1000;
        const startdate = unixTimestamp + 0.24;
        const date_end = new Date(this.dateEnd + 'T23:59:59Z');
        const unixTimestamp_end = date_end.getTime() / 1000;
        const enddate = unixTimestamp_end + 0.24;

          if (monitor.NAME == 'Disk Usage Collection') {
          // try {
            
            const now = new Date();
            const response = await axios.post(
              'metrics-cluster', // URL endpoint
              {
                seqId: server.SEQ_ID,
                datetimes: now.getTime()
              }, // Data yang dikirimkan (kosong jika tidak ada data yang dikirim)
              {
                headers: {
                  'auth-token': localStorage.getItem('token_app')
                },
                // Axios secara otomatis mengonversi respons ke JSON, jadi tidak perlu menambahkan 'dataType: 'json''
              }
            );

            const rawData = response.data.data;
            const categories = rawData.map(item => item.core);
            const dataValues = rawData.map(item => (item.indexSizeBytes));


            // Simpan categories per SEQ_ID series_display
            this.$set(this.categories, monitor.SEQ_ID, categories);

            // Simpan series per SEQ_ID
            this.$set(this.chartSeries, monitor.SEQ_ID, [{
              name: monitor.SEQ_ID,
              data: dataValues
            }]);
      // console.log('categories:', this.categories[this.monitor.SEQ_ID]);
      // console.log('series:', this.chartSeries[this.monitor.SEQ_ID]);

              // window.dispatchEvent(new Event('resize'))
          // } catch (error) {

          //   console.error('Error fetching monitoring data:', error);
          //   return [50, 30, 20];  // Default value in case of error
          // }

        }else   if (monitor.NAME === 'Memory Usage Server/VM') {
          try {
              const totalMemoryQuery = 'node_memory_MemTotal_bytes';
              const freeMemoryQuery = 'node_memory_MemFree_bytes';
              const totalMemoryResponse = await axios.get(prometheusUrlRange, {
                params: { 
                  query: totalMemoryQuery,
                  start: startdate,
                  end: enddate,
                  step: 300
                },
              });
              const freeMemoryResponse = await axios.get(prometheusUrlRange, {
                params: { 
                  query: freeMemoryQuery,
                  start: startdate,
                  end: enddate,
                  step: 300
                },
              });
              const totalMemoryData = totalMemoryResponse.data.data.result;
              const freeMemoryData = freeMemoryResponse.data.data.result;
              let totalMemory = "";
              if (totalMemoryData && totalMemoryData.length > 0 && totalMemoryData[0].values.length > 0) {
                totalMemory = parseFloat(totalMemoryData[0].values[totalMemoryData[0].values.length - 1][1]);
              } else {
                console.error('Error: Total memory data is missing or empty');
              }
              let freeMemory = "";
              if (freeMemoryData && freeMemoryData.length > 0 && freeMemoryData[0].values.length > 0) {
                freeMemory = parseFloat(freeMemoryData[0].values[freeMemoryData[0].values.length - 1][1]);
              } else {
                console.error('Error: Free memory data is missing or empty');
              }
              if (typeof totalMemory === 'number' && typeof freeMemory === 'number') {
                const usedMemory = totalMemory - freeMemory;
                const freeMemoryInGB = (freeMemory / (1024 * 1024 * 1024)).toFixed(2);
                const usedMemoryGB = (usedMemory / (1024 * 1024 * 1024)).toFixed(2);
                const chartData = [parseFloat(usedMemoryGB), parseFloat(freeMemoryInGB)];
                this.$set(this.chartSeries, monitor.SEQ_ID, chartData); 
              }
              // node cpu jvm solr
                const cpuPresentase = 'avg by(instance) (rate(node_cpu_seconds_total{mode=~"user|system"}[5m])) * 100';

                const presentaseCpuResponse = await axios.get(prometheusUrl, {
                  params: { 
                    query: cpuPresentase,
                    // start: startdate,
                    // end: enddate,
                    // step: 300
                  },
                });
                const tmppresentaseCpuResponse = presentaseCpuResponse.data.data.result;
                let cpujvm = '-';

                if (
                  Array.isArray(tmppresentaseCpuResponse) &&
                  tmppresentaseCpuResponse.length > 0 &&
                  Array.isArray(tmppresentaseCpuResponse[0].value) &&
                  tmppresentaseCpuResponse[0].value.length > 1 &&
                  !isNaN(parseFloat(tmppresentaseCpuResponse[0].value[1]))
                ) {
                  cpujvm = parseFloat(tmppresentaseCpuResponse[0].value[1]).toFixed(2) + ' %';
                }

             
                const usedPercent = ((totalMemory - freeMemory ) / totalMemory) * 100;
                const usedPercentRounded = Math.round(usedPercent * 100) / 100; // bulatkan 2 desimal
                const newData = {
                  CPU: cpujvm,
                  Heap: {
                    presentase: usedPercentRounded+' %',
                    max: formatBytes(totalMemory),
                    used: formatBytes(totalMemory - freeMemory )
                  },
                  DiskUsageSolr: formatBytes(freeMemory),
                  Requests: formatScrapeDuration(0)
                };
                // alert(tmpRequestMs)
                if (!this.tableDataVal) {
                  this.tableDataVal = {};
                }
                this.$set(this.tableDataVal, monitor.SEQ_ID, newData);
              // if (typeof totalMemory === 'number' && typeof freeMemory === 'number') {
              //   return chartData;
              // }
          } catch (error) {
            console.error('Error fetching monitoring data:', error);
            return [50, 30, 20];  // Default value in case of error
          }
        }else  if (monitor.NAME == 'Memory Usage Solr') {
          try {
              const now = new Date();
              const cpuPresentase = '100 * avg_over_time(solr_metrics_jvm_os_cpu_load{item="systemCpuLoad"}[5m])'
              const resCpu = await axios.get(prometheusUrl, {
                params: { 
                  query: cpuPresentase,
                },
              });
              const cpuLoad = Number(resCpu.data.data.result[0].value[1]);
              const dataRes = await axios.post(
                'metrics-system', // URL endpoint
                {
                  seqId:  server.SEQ_ID,
                  datetimes: now.getTime()
                },
                {
                  headers: {
                    'auth-token': localStorage.getItem('token_app')
                  },
                }
              );
              const chartData = [
                  bytesToMBNominal(dataRes.data.data.raw.used),
                  bytesToMBNominal(dataRes.data.data.raw.free)
              ];
              this.$set(this.chartSeries, monitor.SEQ_ID, chartData); 
              // request ms
              const requestMs = 'solr_scrape_duration_seconds';
              const RequestMs = await axios.get(prometheusUrl, {
                params: { 
                  query: requestMs,
                },
              });
              const tmpRequestMs = Number(RequestMs.data.data.result[0].value[1]);
              const newData = {
                CPU: (cpuLoad).toFixed(2)  +` %`,
                Heap: {
                  presentase: (dataRes.data.data.raw.used / dataRes.data.data.raw.total * 100).toFixed(1)  +` %`,
                  max: formatMBtoGB(bytesToMBNominal(dataRes.data.data.raw.total)),
                  used: formatBytes(dataRes.data.data.raw.used )
                },
                DiskUsageSolr: formatBytes(dataRes.data.data.raw.free ),
                Requests: formatScrapeDuration(tmpRequestMs)
              };
              if (!this.tableDataVal) {
                this.tableDataVal = {};
              }
              this.$set(this.tableDataVal, monitor.SEQ_ID, newData);
              // window.dispatchEvent(new Event('resize'))
          } catch (error) {
            console.error('Error fetching monitoring data:', error);
            return [50, 30, 20];  // Default value in case of error
          }

        }else  if (monitor.NAME === 'Swap Space') {
          try {
              //====== swap memory ====
              const totalSwapQuery = 'node_memory_SwapTotal_bytes';
              const usedSwapQuery = 'node_memory_SwapUsed_bytes';
              const freeSwapQuery = 'node_memory_SwapFree_bytes';
              const totalSwapResponse = await axios.get(prometheusUrl, {
                params: { 
                  query: totalSwapQuery
                },
              });

              const usedSwapResponse = await axios.get(prometheusUrl, {
                params: { 
                  query: usedSwapQuery
                },
              });
              const freeSwapResponse = await axios.get(prometheusUrl, {
                params: { 
                  query: freeSwapQuery
                },
              });
              let totalSwap = 0;
              let usedSwap = 0;
              let freeSwap = 0;
              if (totalSwapResponse.data.data.result.length > 0) {
                totalSwap = parseFloat(totalSwapResponse.data.data.result[0].value[1]);
              }
              if (freeSwapResponse.data.data.result.length > 0) {
                freeSwap = parseFloat(freeSwapResponse.data.data.result[0].value[1]);
              }
              // Calculate the free swap space as totalSwap - usedSwap if it's not available
              if (isNaN(freeSwap) && !isNaN(totalSwap) && !isNaN(usedSwap)) {
                freeSwap = totalSwap - usedSwap;
              }
              if (usedSwapResponse.data.data.result.length > 0) {
                usedSwap = parseFloat(usedSwapResponse.data.data.result[0].value[1]);
              }else{
                usedSwap = totalSwap - freeSwap;
              }
              // Store the swap data
              this.totalSwap = totalSwap;
              this.usedSwap = usedSwap;
              this.freeSwap = freeSwap;
              const usedSwapInGB = (this.usedSwap / (1024 * 1024 * 1024)).toFixed(2); // Used Swap in GB
              const freeSwapInGB = (this.freeSwap / (1024 * 1024 * 1024)).toFixed(2); // Free Swap in GB
              this.totalSwapGb = (this.totalSwap / (1024 * 1024 * 1024)).toFixed(2); // Total Swap in GB
              const chartData2  = [parseFloat(usedSwapInGB), parseFloat(freeSwapInGB)];
              
              this.$set(this.chartSeries, monitor.SEQ_ID, chartData2); 
              
              return chartData2;
          } catch (error) {
            console.error('Error fetching monitoring data:', error);
            return [50, 30];  // Default value in case of error
          }
        }else  if (monitor.NAME === 'File Descriptor Count') {
          // ==== file count ====
          try {

              const fileAvail = 'node_memory_Active_file_bytes';
              const filefree = 'node_memory_Inactive_file_bytes';
              const countavail = await axios.get(prometheusUrl, {
                params: { 
                  query: fileAvail
                },
              });
              const countUsed = await axios.get(prometheusUrl, {
                params: { 
                  query: filefree
                },
              });
              // Mengekstrak nilai dari respons Prometheus (value[1] adalah nilai metrik)
              let availCount = parseFloat(countavail.data.data.result[0].value[1]);
              let usedCount = parseFloat(countUsed.data.data.result[0].value[1]);
              
              if (parseFloat(usedCount) >= 1000000) {
                usedCount = (parseFloat(usedCount) / 1000000).toFixed(2) + ' Mil'; 
              }
              
              if (parseFloat(availCount) >= 1000000) {
                availCount = (parseFloat(availCount) / 1000000).toFixed(2) + ' Mil'; 
              }

              const chartFileCountSeries = [parseFloat(usedCount), parseFloat(availCount)];
              this.$set(this.chartSeries, monitor.SEQ_ID, chartFileCountSeries); 
              return chartFileCountSeries;
          } catch (error) {
            console.error('Error fetching monitoring data:', error);
            return [50, 30];  // Default value in case of error
          }

        }else {
          try {
            let dataquery = await axios.get(prometheusUrlRange, {
              params: { 
                query: monitor.QUERY,
                start: startdate,
                end: enddate,
                step:300
              },
            });
            // Menangani data yang dikembalikan
            let data = dataquery.data.data.result[0].values;  // Mengambil values dari response
            let memoryInGB = ""

            let chartData = [{
              name: monitor.SEQ_ID,  // Nama seri
              data: data.map(item => {
                // if(item[1] < 100000000){
                   memoryInGB = item[1];
                // }else{
                //    memoryInGB = item[1] / (1024 * 1024 * 1024);
                // }
                let timestamp = new Date(item[0] * 1000);
                return [timestamp.getTime(), parseFloat(memoryInGB).toFixed(2)];
              })
            }];
            this.$set(this.chartSeries, monitor.SEQ_ID, chartData); 
            // console.log(chartData)
            return chartData;
          } catch (error) {
            console.error('Error fetching monitoring data:', error);
            return [50, 30];  // Default value in case of error
          }
        }
    },

    extractMemoryValue(data) {
      if (data && data.length > 0 && data[0].values.length > 0) {
        return parseFloat(data[0].values[data[0].values.length - 1][1]);
      }
      console.error('Error: Monitoring data is missing or empty');
      return 0;
    },

    async dialogConfirmReset() {
      this.loaddatamonitoring();
    },
    async loaddatamonitoring() {
      const date_awal = new Date();
        const date = new Date();
        date.setDate(date.getDate()+0);
        const datenow = date.toISOString().substr(0, 10);
        if (this.selectedPeriode == "Today") {
          this.click = 'Today'
          this.dateStart = datenow;
          this.dateEnd = datenow;
        }
        if (this.selectedPeriode == "Yesterday") {
          this.click = 'Yesterday'
          date_awal.setDate(date_awal.getDate()-1);
          const date_c = date_awal.toISOString().substr(0, 10);
          this.dateStart = date_c;
          this.dateEnd = date_c;
        }
        if (this.selectedPeriode == "Last 7 Days" ||  this.selectedPeriode == "Previous Week") {
          this.click = 'Last 7 Days'
          date_awal.setDate(date_awal.getDate()-7);
          const date_c = date_awal.toISOString().substr(0, 10);
          this.dateStart = date_c;
          this.dateEnd = datenow;
        }
        if (this.selectedPeriode == "Last 30 Days" || this.selectedPeriode == "Previous Month") {
          this.click = 'Last 30 Days'
          date_awal.setDate(date_awal.getDate()-30);
          const date_c = date_awal.toISOString().substr(0, 10);
          this.dateStart = date_c;
          this.dateEnd = datenow;
        }
      this.dialogLoading = true;
      const result = await axios.post(
        'monitoring', // URL endpoint
        {}, // Data yang dikirimkan (kosong jika tidak ada data yang dikirim)
        {
          headers: {
            'auth-token': localStorage.getItem('token_app')
          },
        }
      );
      var data = decryptionData(result.data);
      this.matricexplorer = data.data.list_query
      this.serversSelect = data.data.dataServer
      this.servers = data.data.dataMonitoring
      let dataMonitoring = data.data.dataMonitoring
      dataMonitoring.forEach((server) => {
        server.PAR_MONITORING_SERVERs.forEach((monitor) => {
          this.getChartData(server, monitor);
        });
      });

      setTimeout(() =>{
        this.dialogLoading = false;
        window.dispatchEvent(new Event('resize'))

      },1000)
    },

    // add =========================================
    // add =========================================
    // add =========================================
    
    filterItems(item, queryText) {
      // Menyesuaikan pencarian berdasarkan teks input
      if (!queryText) return true;
      // return item.MATRIC.toLowerCase().includes(queryText.toLowerCase());
      return item.MATRIC.includes(queryText);
    },

    
    async selecttypechart() {
        if(this.typechart == "donut"){
          this.donut_attr = true
          this.area_attr = false
          this.bar_attr = false
          
        }else if(this.typechart == "bar"){
          this.donut_attr = false
          this.area_attr = false
          this.bar_attr = true
        }else {
          this.donut_attr = false
          this.area_attr = true
          this.bar_attr = false
        }
      },
    addMonitoring(){
      this.dialogactionmonitoring = true
    },
    
    
    suntingMonitoring(){
      this.btnShowActin = false
      this.btnActionSunting = true
      this.btnActionChart = true
    },

    
    finishSuntingMonitoring(){
      this.btnShowActin = true
      this.btnActionSunting = false
      this.btnActionChart = false
    },
    
    deleteItem(seq_id){ 
      this.seqId = seq_id
      this.dialogDelete = true
    },
    
    
    deleteItemConfirm () {
      this.dialogLoading = true;

      axios({
        method: "delete",
        url: "/monitoring/delete",
        data: {
          id: this.seqId
        },
        headers:{'auth-token':localStorage.getItem('token_app')},
        dataType: 'json'
      })
      .then((response) => {
        // handle success
        this.loaddatamonitoring();
            var status = response.data.status
            var messages = response.data.msg
            if(status == 200){
              this.alertSuccess = true;
              this.alert_err_attention =  messages;
              this.btnload = false
              this.closeDelete()
            }else{
                this.alertFailed = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.closeDelete()
            } 
      this.dialogLoading = false;

      })
      .catch(function (error) {
        console.log(error);
        this.alertFailed = true;
        this.alert_err_attention =  'Delete Failed';
        this.btnload = false
      this.dialogLoading = false;

      })
    },
    sendtmp(selectedSeqId) {
      this.tmp_server = this.serversSelect.find(
        server => server.SEQ_ID === selectedSeqId
      );

      if (this.tmp_server) {
        this.tmp_host = this.tmp_server.HOST
        this.tmp_host_range = this.tmp_server.HOST_RANGE
        this.tmp_host_solr = this.tmp_server.HOST_SOLR
        
      } else {
        console.log('No item selected');
      }
    },
    async displayMonitoring() {
      const datest = new Date(this.dateStart + 'T00:00:00Z');
      const unixTimestamp = datest.getTime() / 1000;
      const startdate = unixTimestamp + 0.24;
      const date_end = new Date(this.dateEnd + 'T23:59:59Z');
      const unixTimestamp_end = date_end.getTime() / 1000;
      const enddate = unixTimestamp_end + 0.24;
      this.displayMemoryUsag = false;
      this.selecttypechart() //refresh chart update
      if (this.typechart === 'bar') {
            this.type_chart_display = 'bar';

              try {
                
                  const now = new Date();
                  const response = await axios.post(
                    'metrics-cluster', // URL endpoint
                    {
                      seqId: this.selectedServerId,
                      datetimes: now.getTime()
                    }, // Data yang dikirimkan (kosong jika tidak ada data yang dikirim)
                    {
                      headers: {
                        'auth-token': localStorage.getItem('token_app')
                      },
                      // Axios secara otomatis mengonversi respons ke JSON, jadi tidak perlu menambahkan 'dataType: 'json''
                    }
                  );

                  const rawData = response.data.data;
                  const categories = rawData.map(item => item.core);
                  const dataValues = rawData.map(item => (item.indexSizeBytes));
                  // Set series dan chart options
                  this.series_display = [
                    {
                      name: 'Index Size (Bytes)',
                      data: dataValues
                    }
                  ];

                  this.chart_display = {
                    chart: {
                      type: 'bar',
                      className: 'rotated-label-chart'
                    },
                    xaxis: {
                      categories: categories,
                      labels: {
                        rotate: -45
                      }
                    },
                    yaxis: {
                      // logarithmic: true, // ini kuncinya

                      min: 1000000,
                      labels: {
                        formatter: function (val) {
                          if (val >= 1000000000) return (val / 1000000000).toFixed(2) + ' GB';
                          if (val >= 1000000) return (val / 1000000).toFixed(2) + ' MB';
                          return val + ' B';
                        }
                      }
                    },
                    dataLabels: {
                      enabled: true,
                      formatter: function (val) {
                        if (val >= 1000000000) {
                          return (val / 1000000000).toFixed(2) + ' GB';
                        } else if (val >= 1000000) {
                          return (val / 1000000).toFixed(2) + ' MB';
                        } else {
                          return val.toLocaleString() + ' Bytes';
                        }
                      },
                      style: {
                        fontSize: '12px',
                        fontWeight: 'bold',
                        colors: ['#304758'],
                      },
                      offsetY: -10, // pindahkan label sedikit ke atas batang
                      offsetX: 0,
                    },
                    tooltip: {
                      y: {
                          formatter: function (val) {
                            if (val >= 1000000000) {
                              return (val / 1000000000).toFixed(2) + ' GB';
                            } else if (val >= 1000000) {
                              return (val / 1000000).toFixed(2) + ' MB';
                            } else {
                              return val.toLocaleString() + ' Bytes';
                            }
                          }
                      }
                    },
                    plotOptions: {
                      bar: {
                        horizontal: false
                      }
                    }
                  };

              } catch (error) {
                console.error('Error fetching monitoring data:', error);
                return [50, 30, 20];  // Default value in case of error
              }
      }else if (this.typechart === 'donut') {
            this.type_chart_display = 'donut';
            if (this.nameChartDonut === 'Memory Usage Server/VM') {
              try {
                const totalMemoryQuery = 'node_memory_MemTotal_bytes';
                const freeMemoryQuery = 'node_memory_MemFree_bytes';

                const totalMemoryResponse = await axios.get(this.tmp_host_range, {
                  params: { 
                    query: totalMemoryQuery,
                    start: startdate,
                    end: enddate,
                    step: 300
                  },
                });

                const freeMemoryResponse = await axios.get(this.tmp_host_range, {
                  params: { 
                    query: freeMemoryQuery,
                    start: startdate,
                    end: enddate,
                    step: 300
                  },
                });

                const totalMemoryData = totalMemoryResponse.data.data.result;
                const freeMemoryData = freeMemoryResponse.data.data.result;

                let totalMemory = "";
                if (totalMemoryData && totalMemoryData.length > 0 && totalMemoryData[0].values.length > 0) {
                  totalMemory = parseFloat(totalMemoryData[0].values[totalMemoryData[0].values.length - 1][1]);
                } else {
                  console.error('Error: Total memory data is missing or empty');
                }

                let freeMemory = "";
                if (freeMemoryData && freeMemoryData.length > 0 && freeMemoryData[0].values.length > 0) {
                  freeMemory = parseFloat(freeMemoryData[0].values[freeMemoryData[0].values.length - 1][1]);
                } else {
                  console.error('Error: Free memory data is missing or empty');
                }

                if (typeof totalMemory === 'number' && typeof freeMemory === 'number') {
                  const usedMemory = totalMemory - freeMemory;
                  const freeMemoryInGB = (freeMemory / (1024 * 1024 * 1024)).toFixed(2);
                  const usedMemoryGB = (usedMemory / (1024 * 1024 * 1024)).toFixed(2);
                  
                  this.series_display = [parseFloat(usedMemoryGB), parseFloat(freeMemoryInGB)];
                  this.chart_display = {
                    chart: {
                      type: 'donut',
                      height: 300,
                    },
                    labels: ['Used Swap', 'Free Swap'],
                    
                    legend: {
                          position: 'bottom',
                        },
                        
                    tooltip: {
                      y: {
                        formatter: function (val) {
                          return `${val} GB`; // Show GB in tooltip
                        }
                      }
                    },
                    
                    plotOptions: {
                      pie: {
                        donut: {
                          labels: {
                            show: true,
                            name: {
                              show: true,
                              fontSize: '22px',
                              color: '#226077',
                              offsetY: -10,
                            },
                            total: {
                              show: true,
                              formatter: function (w) {
                                // Format the total value to two decimal places
                                return w.globals.seriesTotals.reduce((a, b) => a + b, 0).toFixed(2) + ' GB'; // Example: Show in GB
                              }
                            },
                          }
                        }
                      }
                    },
                  };
                  
                }
                this.displayMemoryUsag = true
              // node cpu jvm solr
                const cpuPresentase = 'solr_metrics_jvm_os_cpu_load{instance="172.20.4.13:9983", item="processCpuLoad", job="solr"} * 100';

                const presentaseCpuResponse = await axios.get(this.tmp_host, {
                  params: { 
                    query: cpuPresentase,
                  },
                });
                const tmppresentaseCpuResponse = presentaseCpuResponse.data.data.result;
                // const cpujvm = (parseFloat(tmppresentaseCpuResponse[0].value[1]).toFixed(2) + ' %');
                let cpujvm = '-';

                if (
                  Array.isArray(tmppresentaseCpuResponse) &&
                  tmppresentaseCpuResponse.length > 0 &&
                  Array.isArray(tmppresentaseCpuResponse[0].value) &&
                  tmppresentaseCpuResponse[0].value.length > 1 &&
                  !isNaN(parseFloat(tmppresentaseCpuResponse[0].value[1]))
                ) {
                  cpujvm = parseFloat(tmppresentaseCpuResponse[0].value[1]).toFixed(2) + ' %';
                }

             
              // Heap jvm solr
                const heapMemory = 'solr_metrics_jvm_memory_heap_bytes{instance="172.20.4.13:9983"} / (1024 * 1024 * 1024)';

                const MemoryHeapResponse = await axios.get(this.tmp_host, {
                  params: { 
                    query: heapMemory,
                  },
                });
                const tmpMemoryHeapResponse = MemoryHeapResponse.data.data.result;
                const heapjvmMax = (parseFloat(tmpMemoryHeapResponse[0].value[1]).toFixed(2) + ' GB');


                const heapMemoryUsed = 'solr_metrics_jvm_memory_pools_bytes{base_url="http://localhost:8993/solr", instance="172.20.4.13:9983", item="committed", job="solr", space="G1-Old-Gen"}';

                const MemoryUsedHeapResponse = await axios.get(this.tmp_host, {
                  params: { 
                    query: heapMemoryUsed,
                  },
                });
                const tmpMemoryUsedHeapResponse = MemoryUsedHeapResponse.data.data.result;
                const usedBytes = Number(tmpMemoryUsedHeapResponse[0].value[1]); // pastikan jadi number
                let heapjvmUsed;
                const usedGB = usedBytes / (1024 ** 3);

                if (usedGB < 1) {
                  const usedMB = usedBytes / (1024 ** 2);
                  heapjvmUsed = usedMB + ' MB';
                } else {
                  heapjvmUsed = usedGB + ' GB';
                }
                // Ambil nilai max dalam bytes dari tmpMemoryHeapResponse
                const maxBytes = Number(tmpMemoryHeapResponse[0].value[1]);
                const heapUsagePercent = (usedGB / maxBytes) * 100;
                const heapUsagePercentFormatted =  heapUsagePercent.toFixed(2)  + ' %';
                // collection aktif
                const collectionAktif = 'solr_metrics_core_index_size_bytes';

                const ColectionAktif = await axios.get(this.tmp_host, {
                  params: { 
                    query: collectionAktif,
                  },
                });
                const tmpColectionAktif = ColectionAktif.data.data.result;
                let DiskUsageSolr = 0;
                for(const dt of tmpColectionAktif) {
                  DiskUsageSolr += parseFloat(dt.value[1]);
                }
                // request ms
                const requestMs = 'solr_scrape_duration_seconds';
                const RequestMs = await axios.get(this.tmp_host, {
                  params: { 
                    query: requestMs,
                  },
                });
                const tmpRequestMs = Number(RequestMs.data.data.result[0].value[1]);
                // value[1]
                this.tableData = {
                  CPU: cpujvm,
                  Heap: {
                    presentase: heapUsagePercentFormatted,
                    max: heapjvmMax,
                    used: heapjvmUsed 
                  },
                  DiskUsageSolr: formatBytes(DiskUsageSolr),
                  Requests: formatScrapeDuration(tmpRequestMs)
                };
              } catch (error) {
                console.error('Error fetching monitoring data:', error);
                return [50, 30, 20];  // Default value in case of error
              }
            }else if (this.nameChartDonut === 'Memory Usage Solr') {
              try {
                const now = new Date();
                const cpuPresentase = '100 * avg_over_time(solr_metrics_jvm_os_cpu_load{item="systemCpuLoad"}[5m])'
                const resCpu = await axios.get(this.tmp_host, {
                  params: { 
                    query: cpuPresentase,
                  },
                });
                const cpuLoad = Number(resCpu.data.data.result[0].value[1]);
                const dataRes = await axios.post(
                  'metrics-system', // URL endpoint
                  {
                    seqId: this.selectedServerId,
                    datetimes: now.getTime()
                  }, // Data yang dikirimkan (kosong jika tidak ada data yang dikirim)
                  {
                    headers: {
                      'auth-token': localStorage.getItem('token_app')
                    },
                    // Axios secara otomatis mengonversi respons ke JSON, jadi tidak perlu menambahkan 'dataType: 'json''
                  }
                );

                this.series_display = [
                  bytesToMBNominal(dataRes.data.data.raw.used),
                  bytesToMBNominal(dataRes.data.data.raw.free)
                ];
                console.log( this.series_display)

                this.chart_display = {
                  chart: {
                    type: 'donut',
                    height: 300,
                  },
                  // chart: {
                  //   type: 'donut',
                  //   height: 300,
                  //   events: {
                  //     dataPointMouseEnter: (event, chartContext, config) => {
                  //       console.log('aaaa')
                  //       this.hoveredValue = (chartContext.w.config.series[config.seriesIndex]);
                  //       // this.updateLabels( this.hoveredValue)
                        
                        
                  //     },
                  //     dataPointMouseLeave: () => {
                  //       console.log('bb')
                  //       // this.series_display = this.tmp_series_display 

                  //       this.hoveredValue = null;
                  //     }
                  //   }
                  // },
                  labels: ['Used', 'Free'],
                  
                  legend: {
                        position: 'bottom',
                      },
                      
                  tooltip: {
                    y: {
                      formatter: function (val) {
                          return val +` MB`;
                      }
                    }
                  },
                  plotOptions: {
                    pie: {
                      donut: {
                        labels: {
                          show: true,
                          name: {
                            show: true,
                            fontSize: '22px',
                            color: '#226077',
                            offsetY: -10,
                          },
                          total: {
                            show: true,
                            formatter: function (w) {
                              return formatMBtoGB(w.globals.seriesTotals.reduce((a, b) => a + b, 0)) + ' GB'; // Example: Show in GB
                            }
                          },
                        }
                      }
                    }
                  },
                };
                  
                const requestMs = 'solr_scrape_duration_seconds';
                const RequestMs = await axios.get(this.tmp_host, {
                  params: { 
                    query: requestMs,
                  },
                });
                const tmpRequestMs = Number(RequestMs.data.data.result[0].value[1]);
                this.displayMemoryUsag = true
                this.tableData = {
                  CPU: (cpuLoad).toFixed(2)  +` %`,
                  Heap: {
                    presentase: (dataRes.data.data.raw.used / dataRes.data.data.raw.total * 100).toFixed(1)  +` %`,
                    max: formatMBtoGB(bytesToMBNominal(dataRes.data.data.raw.total)),
                    used: formatBytes(dataRes.data.data.raw.used )
                  },
                  DiskUsageSolr: formatBytes(dataRes.data.data.raw.free ),
                  Requests: formatScrapeDuration(tmpRequestMs)
                };
                window.dispatchEvent(new Event('resize'))
              } catch (error) {
                console.error('Error fetching monitoring data:', error);
                return [50, 30, 20];  // Default value in case of error
              }
            }else  if (this.nameChartDonut === 'Swap Space') {
              try {
                  //====== swap memory ====
                  const totalSwapQuery = 'node_memory_SwapTotal_bytes';
                  const freeSwapQuery = 'node_memory_SwapFree_bytes';
                  const totalSwapResponse = await axios.get(this.tmp_host, {
                    params: { 
                      query: totalSwapQuery
                    },
                  });
                  const freeSwapResponse = await axios.get(this.tmp_host, {
                    params: { 
                      query: freeSwapQuery
                    },
                  });
                  let totalSwap = 0;
                  let usedSwap = 0;
                  let freeSwap = 0;
                  if (totalSwapResponse.data.data.result.length > 0) {
                    totalSwap = parseFloat(totalSwapResponse.data.data.result[0].value[1]);
                  }
                  if (freeSwapResponse.data.data.result.length > 0) {
                    freeSwap = parseFloat(freeSwapResponse.data.data.result[0].value[1]);
                  }
                  if (isNaN(freeSwap) && !isNaN(totalSwap) && !isNaN(usedSwap)) {
                    freeSwap = totalSwap - usedSwap;
                  }
                  // if (usedSwapResponse.data.data.result.length > 0) {
                  //   usedSwap = parseFloat(usedSwapResponse.data.data.result[0].value[1]);
                  // }else{
                    usedSwap = totalSwap - freeSwap;
                  // }
                  // Store the swap data
                  this.totalSwap = totalSwap;
                  this.usedSwap = usedSwap;
                  this.freeSwap = freeSwap;
                  const usedSwapInGB = (this.usedSwap / (1024 * 1024 * 1024)).toFixed(2); // Used Swap in GB
                  const freeSwapInGB = (this.freeSwap / (1024 * 1024 * 1024)).toFixed(2); // Free Swap in GB
                  this.totalSwapGb = (this.totalSwap / (1024 * 1024 * 1024)).toFixed(2); // Total Swap in GB
                  this.series_display  = [parseFloat(usedSwapInGB), parseFloat(freeSwapInGB)];
                  this.chart_display = {
                    chart: {
                      type: 'donut',
                      height: 300,
                    },
                    labels: ['Used Swap', 'Free Swap'],
                     
                    legend: {
                          position: 'bottom',
                        },
                        
                    tooltip: {
                      y: {
                        formatter: function (val) {
                          return `${val} GB`; // Show GB in tooltip
                        }
                      }
                    },
                    
                    plotOptions: {
                      pie: {
                        donut: {
                          labels: {
                            show: true,
                            name: {
                              show: true,
                              fontSize: '22px',
                              color: '#226077',
                              offsetY: -10,
                            },
                            total: {
                              show: true,
                              formatter: function (w) {
                                // Format the total value to two decimal places
                                return w.globals.seriesTotals.reduce((a, b) => a + b, 0).toFixed(2) + ' GB'; // Example: Show in GB
                              }
                            },
                          }
                        }
                      }
                    },
                  };
              } catch (error) {
                console.error('Error fetching monitoring data:', error);
                return [50, 30];  // Default value in case of error
              }
            }else  if (this.nameChartDonut === 'File Descriptor Count') {
              // ==== file count ====
              try {

                  const fileAvail = 'node_memory_Active_file_bytes';
                  const filefree = 'node_memory_Inactive_file_bytes';
                  const countavail = await axios.get(this.tmp_host, {
                    params: { 
                      query: fileAvail
                    },
                  });
                  const countUsed = await axios.get(this.tmp_host, {
                    params: { 
                      query: filefree
                    },
                  });
                  // Mengekstrak nilai dari respons Prometheus (value[1] adalah nilai metrik)
                  let availCount = parseFloat(countavail.data.data.result[0].value[1]);
                  let usedCount = parseFloat(countUsed.data.data.result[0].value[1]);
                  
                  if (parseFloat(usedCount) >= 1000000) {
                    usedCount = (parseFloat(usedCount) / 1000000).toFixed(2) + ' Mil'; 
                  }
                  
                  if (parseFloat(availCount) >= 1000000) {
                    availCount = (parseFloat(availCount) / 1000000).toFixed(2) + ' Mil'; 
                  }
                  this.series_display = [parseFloat(usedCount), parseFloat(availCount)];
                  this.chart_display = {
                    chart: {
                      type: 'donut',
                      height: 300,
                    },
                    labels: ['Used File Descriptors', 'Available File Descriptors'],
                     
                    legend: {
                          position: 'bottom',
                        },
                        
                    tooltip: {
                      y: {
                        formatter: function (val) {
                          
                              if (val >= 1000000) {
                                return (val / 1000000).toFixed(2) + ' Mil'; 
                              }
                              return val.toFixed(2) + ' Mil'; 
                        }
                      }
                    },
                    plotOptions: {
                      pie: {
                        donut: {
                          labels: {
                            show: true,
                            name: {
                              show: true,
                              fontSize: '22px',
                              color: '#226077',
                              offsetY: -10,
                            },
                            total: {
                              show: true,
                              formatter: function (w) {
                                const totalValue = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                                if (totalValue >= 1000000) {
                                  const totalInMillions = (totalValue / 1000000).toFixed(2);
                                  return totalInMillions + ' Mil';
                                }
                                return totalValue.toFixed(2)+ ' Mil'; 
                              }
                            },
                          }
                        }
                      }
                    },
                  };
              } catch (error) {
                console.error('Error fetching monitoring data:', error);
                return [50, 30];  // Default value in case of error
              }

            }
      } else if (this.typechart === 'area') {
        this.type_chart_display = 'area';
        this.chart_display = {}
                  // Fetch Prometheus data for the area chart
          const dataquery = await axios.get(this.tmp_host_range, {
            params: {
              query: this.matricexplorerAdd,
              start: startdate,
              end: enddate,
              step: 300  // 300 seconds (5 minutes) step interval
            },
          });
          // Extract time-series data for the area chart
          const series = [];
          const timestamps = [];
          // Loop through the results and prepare the data for the chart
          dataquery.data.data.result.forEach((metricData) => {
            const dataPoints = [];
            metricData.values.forEach(([timestamp, value]) => {
              const date = new Date(timestamp * 1000); // Convert to milliseconds
              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
              const year = date.getFullYear();
              const hours = String(date.getHours()).padStart(2, '0');
              const minutes = String(date.getMinutes()).padStart(2, '0');
              const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;
              timestamps.push(formattedDate);
              dataPoints.push(parseFloat(value));
            });
            series.push({
              name: metricData.metric.__name__, // Metric name as the series name
              data: dataPoints
            });
          });
          this.chart_display = {
            chart: {
              type: 'area',
              height: 300,
            },
            xaxis: {
              categories: timestamps // Set categories (timestamps) for the x-axis
            },
            series: series
          };
          console.log(this.chart_display );
      }
      // Set the title dynamically based on the type of chart
      this.name_title_monitoring = `${this.typechart.charAt(0).toUpperCase() + this.typechart.slice(1)} Chart`;
      // window.dispatchEvent(new Event('resize'))
      this.$nextTick(() => {
        if (this.$refs.apexChartRef?.chart) {
          this.$refs.apexChartRef.chart.resize(); // ✅ ini hanya untuk chart tersebut
        }
        this.btnload = false;
      });

    },
    updateLabels(value = null) {
      if (value !== null) {
        // Jika value ada, kita ubah labels sesuai dengan nilai yang di-hover
        this.chart_display.labels = [
          `Used (${formatBytesAuto(value)})`, 
          `Free (${formatBytesAuto(this.series_display[1])})`
        ];
      } else {
        // Jika tidak ada value (misal mouseLeave), kembalikan ke label default
        this.chart_display.labels = ['Used', 'Free'];
      }
      console.log()
      
      // Pastikan Vue bisa merender ulang perubahan labels
      this.$set(this.chart_display, 'labels', [...this.chart_display.labels]);
    },
    closeMonitoringAction () {
      this.seqId =""
      this.selectedServerId =""
      this.typechart =""
      this.series_display =[]
      this.chart_display ={}
      this.type_chart_display =""
      this.name_title_monitoring =""
      this.selecttypechart()
      this.area_attr =false
      this.donut_attr =false
      this.displayMemoryUsag =false
      this.dialogactionmonitoring =false
      this.btnload = false
    },

    closeMonitoringQuery () {
      this.seqId =""
      this.series_display =[]
      this.chart_display ={}
      this.type_chart_display =""
      this.name_title_monitoring =""
      this.dialogaQuerymonitoring =false
      this.btnload = false

    },
    
    updateMonitoringAction (data,host_solr,host,hostRange) {
      console.log(data)
      this.seqId =data.SEQ_ID
      this.selectedServerId = data.SEQ_ID_MONITORING_SERVER
      this.typechart = data.TYPE
      if(data.TYPE == 'donut'){
        this.nameChartDonut = data.NAME
        this.donut_attr = true
        this.area_attr = false
      }else{
        this.matricexplorerAdd = data.QUERY
        this.namechart = data.NAME
        this.donut_attr = false
        this.area_attr = true
      }
      this.tmp_host = host
      this.tmp_host_range = hostRange
      this.tmp_host_solr = host_solr
      this.dialogactionmonitoring =true
      this.displayMonitoring();
    },
    async postDataMonitoring () {
      this.btnload = true
      let nameChart = this.namechart
      let flagManual = 'Y'
      if(this.typechart == 'donut'){
        nameChart = this.nameChartDonut
        flagManual = 'N'
      }else if(this.typechart == 'bar'){
        nameChart = this.nameChartBar
        flagManual = 'N'
      }
      axios.post("/monitoring-action", 
      {
          seqId :this.seqId,
          seqIdMonitoringServer :this.selectedServerId,
          nameChart : nameChart,
          flagManual : flagManual,
         // query : this.matricexplorerAdd.toLowerCase(),
          query : this.matricexplorerAdd,
          type : this.typechart,
        },
        { headers:{'auth-token':localStorage.getItem('token_app')}},
        {dataType: 'json'}
        )
      .then((response) => {
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.loaddatamonitoring();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.btnload = false
            this.closeMonitoringAction();
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
              this.btnload = false
          } 
        })
      .catch((e) => {
            switch (e.response.status) {
                case 404:
                      this.$refs.alert.error_login(404);
                    break;
                case 403:
                      this.$refs.alert.error_login(403);
                    break;
                case 400:
                      this.alertFailed = true;
                      this.alert_err_attention =  e.response.data.msg;
                      this.btnload = false
                    break;
                default:
                    console.log('some other error');  // end up here all the time
                    break;
                }
        this.errors=e.response.data.msg;
      });  
    },
    
  },
};
</script>

<style> /*note css jangan diubah*/
/* Targeting specific classes */

.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}


.btn-ok-delete{
    background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}

.v-avatar.color-warnning
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}

.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}



.custom-tabs {
  font-weight: 600;
  font-size: 16px;
  text-transform: none; /* agar teks tab normal (tidak uppercase) */

  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  overflow: hidden; /* Agar isi di dalam tidak melebihi radius */
}
.rounded-tabs {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border: 1px solid #ccc;
}

.tab-content-elevated {
  margin-top:-23px;
  border: 1px solid #ccc;
  border-top: 1px solid #ccc;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 16px;
  background-color: white;
}

.custom-tab:hover {
  background-color: rgba(53, 33, 235, 0.1);
}
.theme--light.v-tabs-items{
  /* background-color:#e7e9f505; */
  background-color:#4757b105;
}
.v-window .v-window-item{
  height: 100%;
  width: 100%;
  padding: 9px;
}
.apexcharts-canvas {
  width: 100% !important; 
  margin-left: 0px;
  margin-right: 0px;
  height: 250px !important;
}
.apexcharts-svg {
  margin: 0;
}
.apexchartsavailable-memory-line-chart {
  width: 100% !important; 
  height: 240px !important;
}
.apexcharts-theme-light .apexcharts-xaxis-texts tspan {
  /* Example of changing text color of X-axis labels */
  fill: #226077;
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}
div.apexcharts-canvas.apexcharts-theme-dark {
  background: transparent !important;
}

.tooltip .tooltip-inner {
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 12px !important;
  max-width: 150px;
}
.row-pointer {
  cursor: pointer;
}

.color-avatar {
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
  color: rgb(247, 239, 239);
}
.v-avatar.color-avatar2 {
  background-image:
  linear-gradient(to right top, #ec6497, #ef6d94, #f27693, #f47f92, #f58892, #f78f91, #f99791, #fa9e91, #fca690, #fdae8f, #feb690, #febe91);
}
.theme--light.v-btn{
  color:white;
}


.buttonstyle {
  box-shadow: 0 5px 15px rgba(153, 0, 255, 0.4);
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar5 {
  background-image:
  linear-gradient(to right top, #dc922b, rgb(198, 128, 14), #fec864, #ffcc5e, #ffd057, #ffd359, #ffd65a, #ffd95c, #ffdb66, #ffde6f, #ffe079, #ffe282);
}

.rotated-label-chart .apexcharts-datalabel {
  transform: rotate(-45deg);
  transform-origin: bottom left;
}
</style>